import { render } from "./SlideToUseButton.vue?vue&type=template&id=60dd7d30&scoped=true"
import script from "./SlideToUseButton.vue?vue&type=script&lang=js"
export * from "./SlideToUseButton.vue?vue&type=script&lang=js"

import "./SlideToUseButton.vue?vue&type=style&index=0&id=60dd7d30&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dd7d30"]])

export default __exports__